import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteScholarships = () => {
    const [Scholarships, setScholarships] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedScholarships();
    }, []);

    const fetchDeletedScholarships = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/scholarships/deleted');
            const data = await response.json();
            setScholarships(data);
        } catch (error) {
            console.error('Error fetching deleted Student Loans:', error);
        }
    };

    const handleRestore = async (ScholarshipsId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this scholarship?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/scholarships/restore/${ScholarshipsId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful restoration
                        const updatedScholarships = Scholarships.filter(Scholarships => Scholarships.id !== ScholarshipsId);
                        setScholarships(updatedScholarships);
                        
                        // Show success message
                        Swal.fire({
                            title: "Restored!",
                            text: "The scholarship has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore scholarship');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the scholarship.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring scholarship:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the scholarship.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (ScholarshipsId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the scholarship. This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/scholarships/delete/permanent/${ScholarshipsId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedScholarships = Scholarships.filter(Scholarships => Scholarships.id !== ScholarshipsId);
                        setScholarships(updatedScholarships);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The scholarship has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete scholarship permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the scholarship.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting scholarship permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the scholarship.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter scholarships based on search term
    const filteredScholarships = Scholarships.filter(scholarship => 
        (scholarship.sProgrammeName && scholarship.sProgrammeName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (scholarship.country && scholarship.country.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (scholarship.university && scholarship.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (scholarship.institutePhone && scholarship.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (scholarship.instituteEmail && scholarship.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE SCHOLARSHIPS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Scholarship Programme Name</th>
                                    <th>Country</th>
                                    <th>Offered By</th>
                                    <th>Closing Date </th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredScholarships.map((Scholarships) => (
                                    <tr key={Scholarships.id}>
                                        <td>{Scholarships.sProgrammeName}</td>
                                        <td>{Scholarships.country}</td>              
                                        <td>{Scholarships.university}</td>
                                        <td>{new Date(Scholarships.closingDate).toLocaleDateString('en-CA')}</td>
                                        <td>{Scholarships.institutePhone}</td>
                                        <td>{Scholarships.instituteEmail}</td>
                                        <td>
                                            <a href={Scholarships.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(Scholarships.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(Scholarships.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteScholarships